
var ControlModeDisabled = function() {

};


export default ControlModeDisabled;
